import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function FractionMyData({
  formData,
  updateFormData,
  errors,
  clearFieldError,
  disabled,
  tokens,
  bulkExpressionFile,
}) {
  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e.target;
    clearFieldError(name);
      // Call the handleChange function for other selections
      if (name === "bulkExpressionFile") {
        if (value === "upload") {
          navigate("/uploadfile");
        }
        const [id, fileName] = value.split("|"); // Split the concatenated value
        updateFormData({ [name]: { id, value: fileName } }); // Update with object
      } else if (name === "token") {
        const [id, fileName] = value.split("|"); // Split the concatenated value
        updateFormData({ [name]: { id, value: fileName } });
      } else {
        updateFormData({ [name]: value });
      }
  };

  // useEffect(() => {
  //       const mixtureFile = await fetch(
  //         `${process.env.REACT_APP_API_URL}/api/get-mixture-file`,
  //         {
  //           method: "GET",
  //           credentials: "include",
  //           // headers: {
  //           //   Authorization: `Bearer ${localStorage.getItem("token")}`,
  //           // },
  //         }
  //       ); // Replace with your API endpoint
  //       const files = await mixtureFile.json();
  //       setBulkExpressionFile(files.items);
  //     } catch (error) {
  //       console.error("Error fetching data", error);
  //     }
  //   };

  //   fetchData();
  return (
    <>
      <div
        className="row ps-3 ps-lg-4 pe-3 pe-lg-4 pb-1"
        style={{ paddingTop: "24px" }}
      >
        <div className="col-xl-3 col-lg-4 mb-3">
          <p className="form-label">
            Configure Custom Input
          </p>
        </div>

        <div className="col-xl-6 col-lg-8">
          <div className="form-group">
            <label className="menu-options label-spacing">
              Signature Matrix*
            </label>
            <select
              name="signatureMatrixFile"
              value={formData.signatureMatrixFile}
              onChange={handleChange}
              className="form-select"
              required
              disabled={disabled}
            >
              <option value="blood">Blood: 22 Immune Cell Types</option>
              <option value="tissue">
                Tissue: 25 cell types (22 immune cell types plus fibroblast,
                epithelial, and endothelial cells)
              </option>
            </select>
          </div>

          <div className="form-group">
            <label className="menu-options label-spacing">
              Bulk Expression File*
            </label>
            <select
              name="bulkExpressionFile"
              value={
                formData.bulkExpressionFile?.id
                  ? `${formData.bulkExpressionFile.id}|${formData.bulkExpressionFile.value}`
                  : ""
              }
              onChange={handleChange}
              className="form-select"
              required
              disabled={disabled}
            >
              <option value="" disabled>
                Select...
              </option>
              {bulkExpressionFile.length > 0 ? (bulkExpressionFile.map((file) => (
                <option key={file.id} value={`${file.id}|${file.name}`}>
                  {file.name}
                </option>
              ))) : ""}
              <option value="upload">Go to upload page to upload file.</option>
            </select>
            {errors?.bulkExpressionFile && (
              <p className="error-text">{errors.bulkExpressionFile}</p>
            )}
          </div>

          <div className="form-group">
            <label className="menu-options label-spacing">
              Platform
            </label>
            <select
              name="platform"
              value={formData.platform}
              onChange={handleChange}
              className="form-select"
              disabled={disabled}
            >
              <option value="none">RNA-Seq</option>
              <option value="apply">Microarray</option>
            </select>
          </div>

          <div className="form-group">
            <label className="menu-options label-spacing">
              Sequence Type
            </label>
            <select
              name="sequenceType"
              value={formData.sequenceType}
              onChange={handleChange}
              className="form-select"
              disabled={disabled}
            >
              <option value="Whole Transcriptome Sequencing">
                Whole Transcriptome Sequencing
              </option>
              <option value="Targeted Sequencing: Agilent SureSelect CD CiberMed Heme">
                Targeted Sequencing: Agilent SureSelect CD CiberMed Heme{" "}
              </option>
              <option value="Targeted Sequencing: Agilent SureSelect CD CiberMed Heme+Hires">
                Targeted Sequencing: Agilent SureSelect CD CiberMed Heme+HiRes
              </option>
              <option value="Targeted Sequencing: Agilent SureSelect CD CiberMed Tissue">
                Targeted Sequencing: Agilent SureSelect CD CiberMed Tissue{" "}
              </option>
              <option value="Targeted Sequencing: Other">
                Targeted Sequencing: Other{" "}
              </option>
              <option value="Other/I'd rather not to answer">
                Other/I'd rather not answer{" "}
              </option>
            </select>
          </div>

          <div className="form-group">
            <label className="menu-options label-spacing">
              Token*
            </label>
            <select
              name="token"
              value={
                formData.token?.id
                  ? `${formData.token.id}|${formData.token.value}`
                  : ""
              }
              onChange={handleChange}
              className="form-select"
              required
              disabled={disabled}
            >
              <option value="" disabled>
                Select...
              </option>
              {tokens.length > 0 ? (
                tokens.map((token) => (
                  <option key={token.id} value={`${token.id}|${token.token}`}>
                    {token.token} ({token.type})
                  </option>
                ))
              ) : (
                <option disabled>No valid tokens available for your organisation.</option>
              )}
            </select>
            {errors?.token && <p className="error-text">{errors.token}</p>}
          </div>
        </div>
        <hr
          style={{
            borderTop: "1px solid #EEEEEE",
            opacity: "1",
            marginTop: "6px",
          }}
        />
        <div className="col-xl-3 col-lg-4 mb-3">
          <span className="review-text sub-text">
            Name this run (optional) to find your results easily later (up to 25 characters).
          </span>
        </div>
        <div className="col-xl-6 col-lg-8">
          <div className="form-group">
            <label className="menu-options label-spacing">
              Run Name
            </label>
            <input
              type="text"
              name="runName"
              value={formData.runName}
              onChange={handleChange}
              placeholder="e.g. My Sample Run"
              maxLength={25}
              disabled={disabled}
            />
          </div>
        </div>
      </div>
    </>
  );
}
